import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom"
import styles from "./NavBar.module.css";
import { Search } from "../Search/Search";
import { ProfileDropdown } from "../ProfileDropdown/ProfileDropdown";
import { useNavigationContext, useUpdateNavigationContext } from "../../contexts/NavagationContext";

export const NavBar = () => {

    // ----------------------------------------------------- STATE AND HOOKS
    let token = localStorage.getItem("token");
    var tokenPeices = [];
    var decodedUserID = [];

    if (token !== null) {
        tokenPeices = token.split(".");
        decodedUserID = atob(tokenPeices[1]);
    }

    const currentLocation = useNavigationContext();
    const updateCurrentLocation = useUpdateNavigationContext();

    // MOBILE state vatrs
    const [isHamburgerOpen, setIsHambergerOpen] = useState(false);
    const [isSearchOpen, setIsSearchOpen] = useState(false);
    const [isProfileOpen, setIsProfileOpen] = useState(false);

    const defaultLibrary = getDefaultLibrary();

    // ----------------------------------------------------- PRE-RENDER

    const toggleIsHambergerOpen = () => {
        // toggles hamberger menu
        setIsHambergerOpen(!isHamburgerOpen);

        setIsProfileOpen(false);
        setIsSearchOpen(false);
    }

    const toggleIsSearchOpen = () => {
        // toggles search menu
        setIsSearchOpen(!isSearchOpen);

        setIsHambergerOpen(false);
        setIsProfileOpen(false);
    }

    const closeOverlays = () => {
        // closes all overlays
        setIsHambergerOpen(false);
        setIsProfileOpen(false);
        setIsSearchOpen(false);
    }

    function getDefaultLibrary() {
        // gets stored default library or sets new one
        let storedValue = localStorage.getItem("default_library");
        if (storedValue === null) {
            localStorage.setItem("default_library", "read")
            return "read"
        } else {
            return storedValue;
        }
    }

    function makeLinks() {
        // makes link objects 

        if (window.screen.width < 500) {
            // MOBILE
            // return (
            //     <div className={styles.mobileLinksContainer}>
            //         <div className={styles.movileHomeLink}>
            //             <Link to="/" onClick={closeOverlays}>
            //                 <img src="/cat.png" className={styles.mobileIcon} />
            //             </Link>
            //         </div>
            //         <div className={styles.mobileLinks}>
            //             <img src={isSearchOpen ? "/assets/images/searchIconGray.svg" : "/assets/images/searchIconLight.svg"}
            //                 className={styles.searchIcon}
            //                 onClick={toggleIsSearchOpen}
            //                 alt="search icon" />
            //             <img src={isHamburgerOpen ? "/assets/images/hamburgerLight.svg" : "/assets/images/hamburger.svg"}
            //                 className={styles.hamburger}
            //                 onClick={toggleIsHambergerOpen}
            //                 alt="hamberger menu" />
            //         </div>
            //     </div>
            // )
            return (
                <div className={styles.mobile_links}>
                    <Link to="/" className={currentLocation === "home" ? styles.mobile_link_active : styles.mobile_link_inactive}>
                        <img src="/cat.png" className={styles.mobile_logo} />
                        <h5 className={styles.mobile_link_title}>Home</h5>
                    </Link >

                    {currentLocation === "library" ?
                        <Link to={"/library?page=1&library=" + defaultLibrary + "&type=0&genre=0"}
                            className={styles.mobile_link_active}>
                            <img src="assets/images/libraryDark.svg" className={styles.mobile_logo} alt="active library icon" />
                            <h5 className={styles.mobile_link_title}>Library</h5>
                        </Link>
                        :
                        <Link to={"/library?page=1&library=" + defaultLibrary + "&type=0&genre=0"}
                            className={styles.mobile_link_inactive}>
                            <img src="/assets/images/library.svg" className={styles.mobile_logo} alt="inactive library icon" />
                            <h5 className={styles.mobile_link_title}>Library</h5>
                        </Link>
                    }

                    {currentLocation === "tags" ?
                        <Link to='/tags' className={styles.mobile_link_active}>
                            <img src="/assets/images/tagDark.svg" className={styles.mobile_logo} alt="active tag icon"/>
                            <h5 className={styles.mobile_link_title}>Tags</h5>
                        </Link>
                        :
                        <Link to='/tags' className={styles.mobile_link_inactive}>
                            <img src="/assets/images/tag.svg" className={styles.mobile_logo} alt="inactive tag icon"/>
                            <h5 className={styles.mobile_link_title}>Tags</h5>
                        </Link>
                    }

                    {currentLocation === "catalog" ?
                        <Link to='/catalog?page=1&genre=0&type=0' className={styles.mobile_link_active }>
                            <img src="/assets/images/catalogDark.svg" className={styles.mobile_logo} alt="active catalog icon"/>
                            <h5 className={styles.mobile_link_title}>Catalog</h5>
                        </Link>
                        :
                        <Link to='/catalog?page=1&genre=0&type=0' className={styles.mobile_link_inactive}>
                            <img src="/assets/images/catalog.svg" className={styles.mobile_logo} alt="inactive catalog icon" />
                            <h5 className={styles.mobile_link_title}>Catalog</h5>
                        </Link>
                    }

                    {currentLocation === "profile" ?

                        <Link to={`/account/${decodedUserID}`} className={styles.mobile_link_active}>
                            <img src="/assets/images/profileDark.svg" className={styles.mobile_logo} alt="active profile icon"/>
                            <h5 className={styles.mobile_link_title}>Profile</h5>
                        </Link>
                        :

                        <Link to={`/account/${decodedUserID}`} className={styles.mobile_link_inactive}>
                            <img src="/assets/images/profileMoble.svg" className={styles.mobile_logo} about="inactive profile icon"/>
                            <h5 className={styles.mobile_link_title}>Profile</h5>
                        </Link>

                    }


                </div>
            )
        } else if (window.screen.width > 500) {
            // DESKTOP 
            return (
                <div className={styles.content}>
                    <div className={styles.links}>
                        <Link to="/"
                            className={styles.icon}
                            onClick={() => updateCurrentLocation("home")}>
                            <img src="/cat.png" className={styles.icon} />
                        </Link>
                        <Link to="/"
                            className={currentLocation === "home" ? styles.activeNavbarLink : styles.navbarLink}
                            onClick={() => updateCurrentLocation("home")}>
                            Home
                        </Link>
                        <Link to={"/library?page=1&library=" + defaultLibrary + "&type=0&genre=0"}
                            className={currentLocation === "library" ? styles.activeNavbarLink : styles.navbarLink}
                            onClick={() => updateCurrentLocation("library")}>
                            Library
                        </Link>
                        <Link to='/tags'
                            className={currentLocation === "tags" ? styles.activeNavbarLink : styles.navbarLink}
                            onClick={() => updateCurrentLocation("tags")}>
                            Tags
                        </Link>
                        <Link to='/catalog?page=1&genre=0&type=0'
                            className={currentLocation === "catalog" ? styles.activeNavbarLink : styles.navbarLink}
                            onClick={() => updateCurrentLocation("catalog")}>
                            Catalog
                        </Link>
                    </div>
                    <div className={styles.searchAndProfile}>
                        <Search />
                        <div className={styles.profile}><ProfileDropdown /></div>
                    </div>
                </div>
            )
        }
    }

    const links = makeLinks();

    // ----------------------------------------------------- RENDER

    if (window.screen.width > 500) {
        // DESKTOP
        return (
            <section className={styles.container}>
                {links}
            </section>
        )
    } else {
        // MOBILE

        return (
            <section className={styles.mobile_container}>
                <div className={styles.mobile_searchbar}>
                    <Search />
                </div>
                <div className={styles.mobile_taskbar}>
                    {links}
                </div>
            </section>
        )
    }

}